import React, { useEffect, useState } from "react";
import TableAction from "../../../components/TableAction";
// import InputsTable from '../../../components/tables/InputsTable'
import { Button, Input, Modal, Select } from "antd";
// import { useInputCategoryList } from '../../../api/input';
// import InputModal from '../../../components/modals/InputModal';
// import OrdersTable from '../../../components/tables/order/OrdersTable';
import WithAuth from "../../../hoc/WithAuth";
import { useNavigate } from "react-router-dom";
// import OffTakersTable from '../../../components/tables/OffTakersTable';
import OffTakerOrdersTable from "../../../components/tables/order/OffTakerOrdersTable";

function MyOrdersPage() {
  const navigate = useNavigate();
  const [selectedId, setSelectedId] = useState<string>("");
  const [open, setOpen] = useState(false);

  const hideModal = () => {
    setOpen(false);
  };

  return (
    <div
      style={{ borderRadius: 8.5, marginTop: 25, paddingTop: 22 }}
      className="bg-transparent lg:bg-white"
    >
      <OffTakerOrdersTable />
    </div>
  );
}

export default WithAuth(MyOrdersPage);
